import React, {useEffect} from "react";
import { Modal, Rate, Form, Input, Spin } from "antd";
import icon from "../../assets/icons/deleteIcon.svg";
import { FaStar } from "react-icons/fa6";

const RateReviewModal = ({
  isOpen,
  onCancel,
  onSubmit,                 // ({ rating, review_text }) => void
  title = "Leave a review?",
  submitText = "YES",
  cancelText = "NO",
  initialRating = 5,
  initialComment = "",
  loading = false,

  rating,
  comment,
  onChangeRating,
  onChangeComment,

  // star styling
  starSize = 28,
  starColor = "#FFEE59",     // fill color for selected stars
  starStroke = "rgba(243,238,238,0.5)",    // outline color for both states
  defaultStarColor = "#A1A1A180",
  starStrokeWidth = 20,      // SVG stroke width (balanced for react-icons size)
}) => {
  const [form] = Form.useForm();

    useEffect(() => {
        if (isOpen) {
            form.setFieldsValue({
                rating: initialRating,
                review_text: initialComment,
            });
        } else {
            form.resetFields();
        }
    }, [isOpen, initialRating, initialComment, form]);

  const handleFinish = (values) => {
    onSubmit?.(values); // { rating, review_text }
  };

  return (
    <Modal
      title={
              <div className="flex items-center justify-center gap-3 mb-5">
                  <div>
                      {
                          <img src={icon} alt="Alert icon" />
                      }
                  </div>
                  <p className="font-inter font-medium text-[#071952] text-[18px]">
                      {title}
                  </p>
              </div>
        }
      width={391}
      height={308}
      open={isOpen}
      onCancel={loading ? undefined : onCancel}
      footer={null}
      destroyOnClose
      className="responsive-modal"
      closeIcon={
        <div className="flex justify-center text-[24px] w-[24px] h-[24px] p-0 font-normal pointer-events-none">×</div>
      }
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        className="space-y-4"
        initialValues={{ rating: initialRating, review_text: initialComment }}
      >
        {/* Rating with stroked stars */}
          <Form.Item
              name="rating"
              rules={[{ required: true, message: "Please select a rating!" }]}
          >
              <div className="flex items-center justify-center gap-3 mb-5">
                  <Rate
                      allowClear={false}
                      style={{ fontSize: starSize }}
                      value={rating}
                      onChange={onChangeRating}
                      character={({ index, value = initialRating }) => {
                          const isFilled = value > index;
                          return (
                              <FaStar
                                  style={{
                                      color: isFilled ? starColor : defaultStarColor,
                                      stroke: starStroke,
                                      strokeWidth: starStrokeWidth,
                                  }}
                              />
                          );
                      }}
                      disabled={loading}
                  />
                  {/* numeric display */}
                  <span className="text-[14px] font-[700] text-[#354259]">
                      {rating}/5 Rating
                  </span>
              </div>
          </Form.Item>

          <Form.Item
              name="review_text"
              rules={[{required: true, message: "Please add some feedback!"}]}
          >
              <div className="flex items-center justify-center gap-3 mb-5">
                  <Input.TextArea
                      rows={4}
                      placeholder="Enter your feedback here."
                      maxLength={300}
                      value={comment}
                      showCount={{
                          formatter: ({count, maxLength}) =>
                              `${maxLength - count} characters left`,
                      }}
                      onChange={(e) => onChangeComment?.(e.target.value)}
                      style={{
                          outline: "none",
                          borderColor: "#CECECE",
                          height: 120,
                          width: 319,
                          alignItems: "left"
                      }}
                      onFocus={(e) => (e.target.style.boxShadow = "none")}
                      disabled={loading}
                  />
              </div>
          </Form.Item>

          <div className="flex justify-center gap-3 mt-4">
          <button
            type="button"
            onClick={onCancel}
            className={`w-[66px] border-[#FF0202] text-[#FF0202] h-[30px] border rounded-[3.77px] font-inter font-medium text-xs uppercase`}
            disabled={loading}
          >
            {cancelText}
          </button>

          <button
              onClick={onSubmit}
              className={`w-[66px] h-[30px] bg-[#FF0202] uppercase text-white rounded-[3.77px] font-inter font-medium text-xs transition`}
            onFocus={(e) => (e.target.style.boxShadow = "none")}
            disabled={loading}
          >
            {loading ? (
              <span className="inline-flex items-center gap-2">
                <Spin size="small" />
                <span>Sending</span>
              </span>
            ) : (
              submitText
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default RateReviewModal;
